export interface ConfirmDialogData {
    title: string;
    message?: string | null;
    cancelText?: string;
    confirmText?: string;
    confirmColor?: 'warn' | 'primary' | 'accent' | '';
}

export function ConfirmArchiveResult(config?: Partial<ConfirmDialogData>): ConfirmDialogData {
    return {
        title: config?.title || 'Archive Data',
        message: config?.message || 'Are you sure you want to archive this data?',
        confirmText: config?.confirmText || 'Archive',
    } as ConfirmDialogData;
}

export function ConfirmRemoveFormPage(config?: Partial<ConfirmDialogData>): ConfirmDialogData {
    return {
        title: config?.title || 'Remove Form Page',
        message: config?.message || 'Are you sure you want to remove this page?',
        confirmText: config?.confirmText || 'Remove',
    } as ConfirmDialogData;
}

export function ConfirmRemoveFormSection(config?: Partial<ConfirmDialogData>): ConfirmDialogData {
    return {
        title: config?.title || 'Remove Form Section',
        message: config?.message || 'Are you sure you want to remove this section?',
        confirmText: config?.confirmText || 'Remove',
    } as ConfirmDialogData;
}

export function ConfirmDeleteLinkSessions(config?: Partial<ConfirmDialogData> | number): ConfirmDialogData {

    if (typeof config === 'number') {
        return {
            title: `Confirm delete link session(s)`,
            message: `Are you certain you want to delete ${config} link session(s)? This action is permanent and cannot be undone.`,
            confirmText: 'Delete',
            confirmColor: 'warn',
        } as ConfirmDialogData;
    }

    return {
        title: config?.title || 'Confirm delete link session(s)',
        message: config?.message || 'Are you sure you want to delete these link sessions? This action is permanent and cannot be undone.',
        confirmText: config?.confirmText || 'Delete',
        confirmColor: config?.confirmColor || 'warn',
    } as ConfirmDialogData;
}
